<script lang="ts">
  export let stats: any;

  import StatsExplanation from "./StatsExplanation.svelte";

  const keys = Object.keys(stats);

</script>

<table>
  <thead>
    <tr>
      <th scope="col">Property</th>
      <th scope="col">Value</th>
      <th scope="col">Explanation</th>
    </tr>
  </thead>
  <tbody>
    {#each keys as key}
      <tr>
        <th scope="row">{key}</th>
        <td><mark>{stats[key]}</mark></td>
        <td>
          <StatsExplanation {key} />   
        </td>
      </tr>
    {/each}
  </tbody>
</table>
